import React, { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import { DefaultButton, DisableButton } from "../../components/micro/input";
import { createSignature, getServiceList } from "../../redux/service/slice";
import { useDispatch } from "react-redux";

const SignatureModal = ({
  onClose,
  serviceId,
  search,
  pageCount,
  pageLimit,
  sort_by,
  sort_direction,
  types,
}) => {
  const [showPad, setShowPad] = useState(false);
  const [isSigned, setIsSigned] = useState(false);
  const sigRef = useRef();
  const dispatch = useDispatch();

  const handleStartSigning = () => {
    setShowPad(true);
  };

  const handleSignature = () => {
    if (!sigRef.current.isEmpty()) {
      setIsSigned(true);
    }
  };

  const clearSignature = () => {
    sigRef.current.clear();
    setIsSigned(false);
  };

  const handleConfirm = () => {
    if (!sigRef.current || sigRef.current.isEmpty()) return;

    const signatureImage = sigRef.current.toDataURL("image/png");

    const payload = {
      service_id: serviceId,
      customer_signature: signatureImage,
    };

    dispatch(createSignature(payload)).then((res) => {
      if (res.type === "createSignature/fulfilled") {
        dispatch(
          getServiceList({
            search,
            pageCount,
            pageLimit,
            sort_by,
            sort_direction,
            service_status: "all",
            types,
            status: "all",
          })
        );
      }
      onClose();
    });
  };

  return (
    <div className="model">
      <div
        className="bg-white rounded-md shadow-lg px-10 py-6 w-full max-w-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-center text-[34px] text-primaryBlack  mb-6">
          Acknowledge The Completion for this Request
        </h2>

        {!showPad ? (
          <div
            className="border border-borderTheme rounded-md p-4 cursor-pointer text-textSecondary"
            onClick={handleStartSigning}
          >
            Sign Now
          </div>
        ) : (
          <div className="relative">
            <SignatureCanvas
              ref={sigRef}
              penColor="black"
              onEnd={handleSignature}
              canvasProps={{
                width: 400,
                height: 150,
                className: "border border-#F15B29 rounded w-full",
                style: {
                  borderColor: "#F15B29",
                  borderWidth: "1px",
                  borderStyle: "solid",
                },
              }}
            />
            <label
              //   htmlFor={idFromName}
              className="absolute text-themeBtn pointer-events-none text-base bg-white duration-300 transform -translate-y-5 scale-75 top-2 origin-[0] px-2 peer-focus:px-2 peer-focus peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-5 left-1 font-Proxima"
            >
              Sign Now
            </label>
            <button
              onClick={clearSignature}
              className="text-xs  mt-1 underline"
            >
              Clear Signature
            </button>
          </div>
        )}

        <div className="flex justify-center items-center gap-4 mt-6">
          <button
            onClick={onClose}
            className="text-themeBtn  px-6 py-2.5 rounded border border-themeBtn w-full sm:w-auto"
          >
            Cancel
          </button>

          {!isSigned ? (
            <DisableButton value={"Confirm"} />
          ) : (
            <DefaultButton
              onClick={handleConfirm}
              disabled={!isSigned}
              value={"Confirm"}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SignatureModal;
